import { MenuSource } from '../RMS/rms.services';

export const shouldShowRMSMenuEditor = (menuSource?: MenuSource) => {
  return menuSource !== 'FLIPDISH';
};
